<template>
  <div :id="content.id" class="highlight-container">
    <b-container>
      <b-row>
        <b-col>
          <div class="line"/>
          <div
            v-if="content.animation_type == 1"
            class="text orange"
            v-html="content.text"
          />
          <div
            v-else
            data-splitting="words"
            class="text"
            v-html="content.text"
          />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import "splitting/dist/splitting.css";
import "splitting/dist/splitting-cells.css";
import Splitting from "splitting";
import gsap from 'gsap'
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
export default {
  name: 'Highlight',
  props: ["content"],
  data: function () {
    return {
      tl: null
    }
  },
  mounted() {
    Splitting()
    gsap.registerPlugin(ScrollTrigger);
    if( this.content.animation_type == 1 ){
      gsap.set("#" + this.content.id + " .line" ,{scaleX: 5, scaleY: 2, autoAlpha: 0, x: 100});
      gsap.set("#" + this.content.id + " .text" ,{autoAlpha: 0, x: 500});
      gsap.set("#" + this.content.id + " .color-highlight" ,{autoAlpha: 0});
    }
    else{
      // default animation
      gsap.set("#" + this.content.id + " .line" ,{scaleX: 5, scaleY: 2, autoAlpha: 0, x: 100});
      gsap.set("#" + this.content.id + " .text .word" ,{autoAlpha: 0, y: 50, x: -40});
    }
    this.scrollAnimation();
  },
  methods: {
    scrollAnimation() {
      if( this.content.animation_type == 1 ){
        this.tl = gsap.timeline({
          scrollTrigger: {
            trigger: "#" + this.content.id + " .text",
            start: "10% 55%",
            end: "+=0",
            markers: false,
            scrub: false,
            pin: false,
          }
        });
        this.tl.to("#" + this.content.id + " .line", {scaleX: 1, scaleY: 1, autoAlpha: 1, x: 0, duration: 1.3, ease: "back.out(1.2)"})
        this.tl.to("#" + this.content.id + " .text", {autoAlpha: 1, x: 0, duration: 1, ease: "back.out(1.2)", stagger: 2})
        this.tl.to("#" + this.content.id + " .color-highlight", {autoAlpha: 1, duration: 2, ease: "back.out(1.2)", stagger: 1})
      }
      else{
        this.tl = gsap.timeline({
          scrollTrigger: {
            trigger: "#" + this.content.id + " .text",
            start: "10% 55%",
            end: "+=0",
            markers: false,
            scrub: false,
            pin: false,
          }
        });
        this.tl.to("#" + this.content.id + " .line", {scaleX: 1, scaleY: 1, autoAlpha: 1, x: 0, duration: 1.3, ease: "back.out(1.2)"})
        this.tl.to("#" + this.content.id + " .text .word", {autoAlpha: 1, y: 0, x: 0, skewX: 0, duration: .8, ease: "back.out(1.7)", stagger: .1})
      }
    }
  }
};
</script>

<!-- Use preprocessors via the lang attribute! e.g. <style lang="scss"> -->
<style lang="scss" scoped>
@import "@/assets/scss/bper-fonts.scss";
@import "@/assets/scss/colors.scss";
.highlight-container{
  padding-bottom: 32px;
  .line{
    display: none;
  }
  .text{
    @include highlight;
  }
  .orange{
    color: $bper-arancione;
  }
}
// -- media query desktop
@media only screen 
  and (min-device-width: 1250px)
  and (orientation: landscape)  {
    .highlight-container{
      .line{
        display: block;
        width: 170px;
        height: 1px;
        background-color: $bper-verde-scuro;
        margin-bottom: 24px;
      }
      .text{
        @include highlight--desktop;
        padding-right: 200px;
      }
    }
}
</style>

<style lang="scss">
@import "@/assets/scss/bper-fonts.scss";
@import "@/assets/scss/colors.scss";
.highlight-container{
  .text{
    .color-highlight{
      background: linear-gradient(180deg, rgba($bper-arancione, .25) 0%, rgba($bper-arancione, .25) 0%);
    }
  }
}
</style>